/**
 * Сервис для определения наличия интернета
 */
class OnlineStatusService {
  private isOnline: boolean = navigator.onLine;
  private listeners: Set<(isOnline: boolean) => void> = new Set();

  constructor() {
    window.addEventListener('online', () => {
      this.isOnline = true;
      this.notifyListeners(true);
    });

    window.addEventListener('offline', () => {
      this.isOnline = false;
      this.notifyListeners(false);
    });

    // Периодическая проверка реального соединения
    this.startPeriodicCheck();
  }

  private async checkConnection(): Promise<boolean> {
    try {
      const response = await fetch('/health', {
        method: 'GET',
        cache: 'no-cache',
        signal: AbortSignal.timeout(5000),
      });
      return response.ok;
    } catch {
      return false;
    }
  }

  private async startPeriodicCheck() {
    setInterval(async () => {
      if (navigator.onLine) {
        const actuallyOnline = await this.checkConnection();
        if (actuallyOnline !== this.isOnline) {
          this.isOnline = actuallyOnline;
          this.notifyListeners(actuallyOnline);
        }
      } else if (this.isOnline) {
        this.isOnline = false;
        this.notifyListeners(false);
      }
    }, 10000); // Проверка каждые 10 секунд
  }

  private notifyListeners(isOnline: boolean) {
    this.listeners.forEach((listener) => listener(isOnline));
  }

  public getStatus(): boolean {
    return this.isOnline;
  }

  public subscribe(callback: (isOnline: boolean) => void): () => void {
    this.listeners.add(callback);
    // Вызываем сразу с текущим статусом
    callback(this.isOnline);
    // Возвращаем функцию для отписки
    return () => {
      this.listeners.delete(callback);
    };
  }
}

export const onlineStatusService = new OnlineStatusService();

